module.exports = __webpack_public_path__ + "img/21_3.77ca4eb1.png";